import axios from 'axios'
import url from '../url.js'

function getCarts () {
  return fetch(url.carts, null)
}
function preAdd () {
  return fetch(url.cartPreAdd, null)
}
function addNew (data) {
  return fetch(url.cartAddNew, data)
}
function addCart (data) {
  return fetch(url.cartAdd, data)
}
function remove (data) {
  return fetch(url.cartRemove, data)
}
function edit (data) {
  return fetch(url.cartEdit, data)
}
function checkout (data) {
  return fetch(url.cartCheckout, data)
}
function changeDelivery (data) {
  return fetch(url.cartChangeDelivery, data)
}

function fetch (urlString, data) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'POST',
      url: urlString,
      data: data,
      dataType: 'json'
    })
      .then(response => {
        resolve(response)
      })
  })
}

export default {
  getCarts () {
    return getCarts()
  },
  preAdd () {
    return preAdd()
  },
  addNew (data) {
    return addNew(data)
  },
  addCart (data) {
    return addCart(data)
  },
  remove (data) {
    return remove(data)
  },
  edit (data) {
    return edit(data)
  },
  checkout (data) {
    return checkout(data)
  },
  changeDelivery (data) {
    return changeDelivery(data)
  }
}



// WEBPACK FOOTER //
// ./src/api/cart/index.js